import React, {useState, useContext} from 'react'
import '../../../../../css/puzzles/fourJokers/TheSafe.css'

import cameraImg from '../../../../../images/puzzles/fourJokers/camera.png'

import {LocationPuzzlesContext} from '../../../../../context/LocationPuzzlesContext'

import PuzzleReward from '../../../../../components/PuzzleReward'
import NumberLock from '../../../../../components/NumberLock'
import answerData from '../../answerData'

// below was removed because it does not work with touch screens
//  import SafePuzzle from './SafePuzzle'
// <SafePuzzle setPuzzleSolved={setPuzzleSolved} />

function TheSafe() {
    const [puzzleSolved, setPuzzleSolved] = useState(false)
    const [answer] = useState(answerData.safe)
    const {updatePuzzleList} = useContext(LocationPuzzlesContext)
    
    if (puzzleSolved) {
        setTimeout(() => {
            updatePuzzleList({
                type: 'SOLVE_PUZZLE',
                complete: ['safe', 'jack'],
                newPuzzles: ['cameraJack'],
                itemCollected: true
            })
        }, 10) 
    }
    
    return (
        <>
            {puzzleSolved ?
                <PuzzleReward
                    imgSrc={cameraImg}
                    imgAlt='a camera'
                    text="The safe springs open. Inside is some of the Professor's research and a camera. You can use the camera by clicking on it in your inventory."
                />
            :
                <div className='puzzleContainer'>
                    <NumberLock answer={answer} setPuzzleSolved={setPuzzleSolved} />
                    <p className='puzzlePopUp_text'>What a handy place to keep things safe.</p>
                </div>
            }
        </>
    )
}

export default TheSafe